import * as actionTypes from 'constants/ActionTypes';

export function getTermEntities() {
    return {
        type: actionTypes.GET_TERM_ENTITIES.REQUEST,
    };
}

export function getTermEntitiesResponse(data) {
    if (data) {
        return {
            type: actionTypes.GET_TERM_ENTITIES.SUCCESS,
            data,
        };
    }

    return {
        type: actionTypes.GET_TERM_ENTITIES.FAILURE,
    };
}



// WEBPACK FOOTER //
// ./app/actions/termEntities.js